module.exports = __webpack_public_path__ + "img/idea.8c3d8dfd.png";